<template>
  <div id="CustomPropertiesFormGenerator">
    <div v-for="property in propertiesFormSchema" :key="property.Guid">
      <div class="col-md-12" v-if="property.ChildProperties">
        <h4 class="propertyThemeTitle">{{ property.Title }}</h4>
      </div>
      <template v-if="property.ChildProperties">
        <div
          v-for="childProperty in property.ChildProperties"
          :key="childProperty.Guid"
        >
          <h5
            class="propertyGroupTitle"
            v-if="
              childProperty.Type === 'Group' && childProperty.ChildProperties
            "
          >
            {{ childProperty.Title }}
            <button
              v-show="
                childProperty.Dynamic &&
                childProperty.ChildProperties &&
                childProperty.ChildProperties[0]
              "
              class="btn btn-default btn-fab btn-fab-mini"
              :disabled="
                !globals.isAccessAllowed(
                  'LoopOp_ShopperProperties_Shopper_Update'
                )
              "
              @click.prevent="addDynamicGroup(childProperty)"
            >
              <i class="material-icons text-green">add</i>
            </button>
          </h5>
          <template v-if="childProperty.Dynamic && childProperty.ValueGroups">
            <div
              v-for="valueGroup in childProperty.ValueGroups"
              :key="valueGroup.ValueGroupGuid"
              class="col-md-12"
            >
              <div class="dynamicGroupBorder">
                <div
                  v-for="property in childProperty.ChildProperties"
                  :key="property.Guid"
                  class="col-md-11"
                >
                  <component
                    :is="`${property.PropertyType}Input`"
                    :value="getShopperValues(property, valueGroup)"
                    :readOnly="
                      !globals.isAccessAllowed(
                        'LoopOp_ShopperProperties_Shopper_Update'
                      )
                    "
                    @input="updateShopperValues(property, valueGroup, $event)"
                    v-bind="property"
                  ></component>
                </div>
                <div>
                  <button
                    v-show="childProperty.Dynamic"
                    class="btn btn-default btn-fab btn-fab-mini btn-clear"
                    :disabled="
                      !globals.isAccessAllowed(
                        'LoopOp_ShopperProperties_Shopper_Update'
                      )
                    "
                    @click.prevent="
                      removeDynamicGroup(
                        childProperty,
                        valueGroup.ValueGroupGuid
                      )
                    "
                  >
                    <i class="material-icons text-red">clear</i>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="childProperty.Type === 'Property'">
            <div class="col-md-12 nonDynamicGroup">
              <component
                :is="`${childProperty.PropertyType}Input`"
                :value="getShopperValues(childProperty, null)"
                :readOnly="
                  !globals.isAccessAllowed(
                    'LoopOp_ShopperProperties_Shopper_Update'
                  )
                "
                @input="updateShopperValues(childProperty, null, $event)"
                v-bind="childProperty"
              ></component>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IntegerInput from "./FormComponents/IntegerInput";
import TextInput from "./FormComponents/TextInput";
import SingleSelectInput from "./FormComponents/SingleSelectInput";
import MultiSelectInput from "./FormComponents/MultiSelectInput";
import CheckboxInput from "./FormComponents/CheckboxInput";

const uuidv4 = require("uuid/v4");

export default {
  name: "CustomePropertiesForm",
  components: {
    IntegerInput,
    TextInput,
    SingleSelectInput,
    MultiSelectInput,
    CheckboxInput,
  },
  props: {
    shopperGuid: {
      Type: String,
      default: "",
    },
  },
  data() {
    return {
      propertiesFormSchema: [],
      guidRegex: RegExp(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      ),
    };
  },
  created() {
    this.getShopperPropertiesAsync();
  },
  methods: {
    updateShopperValues(property, valueGroup, value) {
      let valueObject;
      if (!valueGroup) valueObject = property.Values && property.Values[0];
      else {
        valueObject = _.find(
          valueGroup.Values,
          (v) => v.ShopperPropertyGuid === property.Guid
        );
      }
      if (!valueObject) {
        valueObject = {
          ShopperPropertyGuid: property.Guid,
          ShopperValues: [],
        };
        if (valueGroup) {
          if (!valueGroup.Values) valueGroup.Values = [];
          valueGroup.Values.push(valueObject);
        } else {
          if (!property.Values) property.Values = [];
          property.Values.push(valueObject);
        }
      }
      let newShopperValues = [{}];

      // Write current value to ShopperValues
      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          newShopperValues[0].TextValue = value;
          break;
        case "Checkbox":
          if (typeof value === "boolean") newShopperValues[0].BitValue = value;
          break;
        case "SingleSelect":
          if (this.guidRegex.test(value))
            newShopperValues[0].ListValueGuid = value;
          else newShopperValues[0].ListCustomValue = value;
          break;
        case "MultiSelect":
          for (let i = 0; i < value.length; i++) {
            if (!newShopperValues[i]) newShopperValues[i] = {};
            if (this.guidRegex.test(value[i]))
              newShopperValues[i].ListValueGuid = value[i];
            else newShopperValues[i].ListCustomValue = value[i];
          }
          break;
      }

      // Restore old ValueGuids
      for (let i = 0; i < valueObject.ShopperValues.length; i++) {
        if (valueObject.ShopperValues[i].ValueGuid && newShopperValues[i])
          newShopperValues[i].ValueGuid =
            valueObject.ShopperValues[i].ValueGuid;
      }

      valueObject.ShopperValues = newShopperValues;
      this.$forceUpdate();
    },
    getShopperValues(property, valueGroup) {
      let valueObject;
      if (!valueGroup) valueObject = property.Values && property.Values[0];
      else {
        valueObject = _.find(
          valueGroup.Values,
          (v) => v.ShopperPropertyGuid === property.Guid
        );
      }
      let sv = valueObject && valueObject.ShopperValues;

      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          if (!sv || !sv[0] || !sv[0].TextValue) return "";
          return sv[0].TextValue;
        case "Checkbox":
          return sv && sv[0] && sv[0].BitValue;
        case "SingleSelect":
          if (!sv || !sv[0]) return "";
          return sv[0].ListValueGuid || sv[0].ListCustomValue || "";
        case "MultiSelect":
          if (!sv || !sv[0]) return [];
          let result = [];
          for (let el of sv) {
            if (el.ListValueGuid) result.push(el.ListValueGuid);
            if (el.ListCustomValue) result.push(el.ListCustomValue);
          }
          return result;
      }
    },
    addDynamicGroup(dynamicGroup) {
      if (!dynamicGroup.ValueGroups) dynamicGroup.ValueGroups = [];
      let newValueGroupsEntry = {
        ValueGroupGuid: uuidv4(),
        Values: [],
      };

      for (let prop of dynamicGroup.ChildProperties) {
        newValueGroupsEntry.Values.push({
          ShopperPropertyGuid: prop.Guid,
          ShopperValues: [],
        });
      }
      dynamicGroup.ValueGroups.push(newValueGroupsEntry);
      this.$forceUpdate();
    },
    removeDynamicGroup(groupObj, guid) {
      _.remove(groupObj.ValueGroups, (vg) => vg.ValueGroupGuid === guid);
      this.$forceUpdate();
    },
    getPropertyStoreObject() {
      let result = {
        Properties: [],
      };
      this.propertiesFormSchema.forEach((topic) => {
        if (topic.ChildProperties)
          topic.ChildProperties.forEach((secondLevelProp) => {
            if (secondLevelProp.ValueGroups)
              result.Properties.push({
                ValueGroups: secondLevelProp.ValueGroups,
              });
            else if (secondLevelProp.Values)
              result.Properties.push({ Values: secondLevelProp.Values });
          });
      });
      return result;
    },
    getShopperProperties(success, error) {
      this.propertiesFormSchema = [];
      let queryString = `api/ShopperProperty/Shopper/${
        this.shopperGuid || "Sturcture"
      }`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
          success();
        },
        error: () => {
          console.error("Error on GET in getShopperProperties()");
          error();
        },
      });
    },
    /**
     * async version for error bubbeling
     */
    async getShopperPropertiesAsync() {
      this.propertiesFormSchema = [];
      let queryString = `api/ShopperProperty/Shopper/${
        this.shopperGuid || "Sturcture"
      }`;

      const data = await $.ajax({
        method: "GET",
        url: queryString,
      });
      this.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
      return data;
    },
    saveShopperProperties(successCallback, errorCallback) {
      let payload = this.getPropertyStoreObject();
      if (!this.shopperGuid) return payload;
      let queryString = `api/ShopperProperty/Shopper/${this.shopperGuid}`;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          successCallback();
        },
        error: () => {
          console.error("Error on PUT in saveShopperProperties()");
          errorCallback();
        },
      });
    },
  },
};
</script>

<style scoped>
.propertyThemeTitle {
  text-align: center;
  background: #eee;
  font-weight: bold;
  padding: 5px;
}
.propertyGroupTitle {
  text-align: left;
  margin-left: 50px;
}
.dynamicGroupBorder {
  border-radius: 10px;
  border: 1px solid #ccc;
  display: inline-block;
  margin: 1px;
  width: 100%;
}
.nonDynamicGroup {
  display: inline-block;
  width: 100%;
}
.btn-fab-mini {
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  border: 1px solid #ddd;
  background: white !important;
  margin: 5px;
}
.btn-clear {
  position: absolute;
  top: calc(50% - 10px);
  right: 35px;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// CustomPropertiesForm.vue?0b49b3e2